// extracted by mini-css-extract-plugin
module.exports = {"Invoice_main":"Invoice_main"};